import { defineMessage } from 'services/localization';

export const messages = {
    addButtonTitle: defineMessage('create_a_new'),
};

export const workflowsMessages = {
    unnamedName: defineMessage('unnamed_workflow'),
    xeroPoName: defineMessage('purchase_orders'),
    xeroBillName: defineMessage('bills'),
    xeroBillBatchPaymentName: defineMessage('xero_batch_payments'),
    xeroAirwallexBatchPaymentName: defineMessage('airwallex_batch_payments'),
    amaxPayBatchPaymentName: defineMessage('batch_payments'),
    xeroCreditNotesPayableName: defineMessage('ap_credit_notes'),
    xeroInvoiceName: defineMessage('sales_invoices'),
    xeroCreditNotesReceivableName: defineMessage('ar_credit_notes'),
    xeroContactName: defineMessage('contacts'),
    salesQuotesName: defineMessage('quotes'),
    qBooksPoName: defineMessage('purchase_orders'),
    qBooksBillName: defineMessage('bills'),
    qBooksExpenseName: defineMessage('expenses'),
    qBooksInvoiceName: defineMessage('sales_invoices'),
    qBooksVendorName: defineMessage('vendors'),
    qBooksJournalEntryName: defineMessage('journal_entries'),
    netSuiteBillName: defineMessage('bills'),
    netSuitePOName: defineMessage('purchase_orders'),
    netSuiteSalesOrderName: defineMessage('sales_orders'),
    netSuiteInvoiceName: defineMessage('invoices'),
    netSuiteExpenseReportName: defineMessage('expense_reports'),
    netSuiteVRAName: defineMessage('vendor_return_authorization'),
    netSuiteJournalEntryName: defineMessage('journal_entries'),
    netSuiteBillPaymentName: defineMessage('bill_payments'),
    netSuiteRAName: defineMessage('return_authorization'),
    netSuiteVendorName: defineMessage('vendors'),
    netSuiteItemReceiptName: defineMessage('item_receipts'),
    xeroManualJournalName: defineMessage('manual_journals'),
    dearPoName: defineMessage('purchase_orders'),
};

export const filtersMessages = {
    allName: defineMessage('all'),
    acceptedName: defineMessage('accepted'),
    declinedName: defineMessage('declined'),
    onApprovalName: defineMessage('on_approval'),
    approvedName: defineMessage('approved'),
    cancelledName: defineMessage('cancelled'),
    rejectedName: defineMessage('rejected'),
    billedName: defineMessage('billed'),
    notBilledName: defineMessage('not_billed'),
    paidName: defineMessage('paid'),
    awaitingPaymentName: defineMessage('awaiting_payment'),
    partiallyPaidName: defineMessage('partially_paid'),
    failedName: defineMessage('failed'),
    processingName: defineMessage('processing'),
    grnNotReceivedName: defineMessage('not_received'),
    grnPartiallyReceivedName: defineMessage('partially_received'),
    grnFullyReceivedName: defineMessage('fully_received'),
    creditedName: defineMessage('credited'),
    partiallyReceivedTitle: defineMessage('partially_received'),
    pendingReceiptTitle: defineMessage('pending_receipt'),
    pendingBillTitle: defineMessage('pending_bill'),
    closedTitle: defineMessage('closed'),
    onReview: defineMessage('on_review'),
    onHold: defineMessage('on_hold'),
};
